import { CSSProperties } from "react"
import { Blocks } from "./blocks"
import { app } from "../app";

interface Props {
  children: React.ReactNode
  block?: Block
  className?: string
  id?: string
}

export function Container(props: Props) {

  const { block, className, id } = props
  const styles = Blocks.buildStyle(block)

  return <div id={id} className={`py-8 sm:py-12 md:py-16 w-full max-w-full min-w-0 flex items-center justify-center ${className || ""}`}
    style={styles}>
    <div className="w-full max-w-7xl mx-auto min-w-0 px-4 sm:px-6 md:px-8 box-border">
      <div className="w-full max-w-full min-w-0 overflow-x-clip">
        {props.children}
      </div>
    </div>
  </div>

}
